import { render, staticRenderFns } from "./FileUploadWarnings.vue?vue&type=template&id=df5642d8&"
import script from "./FileUploadWarnings.vue?vue&type=script&lang=js&"
export * from "./FileUploadWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports